<template>
    <div class="c-mapbox-templating__zoom">
        <!-- Added by Mapbox -->
    </div>
</template>

<style lang="scss">
    .c-mapbox-templating__zoom {
        display: none;
    }
</style>

<script>
    export default {
        name: "zoom",
        props: {
            map: Object,
            position: String,
        },
        mounted() {
            this.map.layers.zoom = new L.Control.Zoom({ position: this.position });
        }
    };
</script>


// WEBPACK FOOTER //
// Assets/Scripts/Components/Mapbox/zoom/zoom.vue